import { Injectable } from '@angular/core';
import * as WarehouseActionTypes from '../../actions/warehouse/warehouse.actions';
import * as MessagesActionTypes from '../../actions/messages/message.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, catchError, tap } from 'rxjs/operators';
import { from, EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { WarehouseService } from 'src/app/shared/services/warehouses/warehouses.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class WarehouseEffects {


    // Get Sites List
    // Get Contract
    getWarehouseBySite$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(WarehouseActionTypes.getTankListBySite),
                exhaustMap((action) => this.warehouseService.getWarehouseBySite(action.siteCode, action.pageReq)
                    .pipe(
                        map(result => (WarehouseActionTypes.loadTankListBySite({ response: result }))
                        ),

                        catchError((error) => {
                            const actions = [
                                WarehouseActionTypes.setLoadingTanksLoadEnd(),
                                MessagesActionTypes.setMessage(
                                    {
                                        appMessage:
                                        {
                                            key: 'error',
                                            message: this.translate.instant('Warehouses.WarehouseLoadingError'),
                                            owner: 'Warehouses-Management',
                                            severity: 'error',
                                            timestamp: new Date().getTime()
                                        }
                                    }
                                )
                            ];
                            return from(actions);
                        }
                        )
                    )
                )
            )
    );




    constructor(
        private actions$: Actions,
        private store$: Store<AppState>,
        private warehouseService: WarehouseService,
        private router: Router,
        private translate: TranslateService
    ) { }

}
